/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.50
 *
 * Do not edit the class manually.
 *
 */
import { ApiClient } from "../ApiClient";
import { AssessmentDTO } from '../model/AssessmentDTO';
import { RestBodyResponseUtil } from '../model/RestBodyResponseUtil';
import IntegratedSummaryReportDTO from "../model/IntegratedSummaryReportDTO"; 
import TemplateQualitativeAnswerTypeDTO from "../model/TemplateQualitativeAnswerTypeDTO";

/**
* AssessmentService service.
* @module api/AssessmentServiceApi
* @version v0
*/
export class AssessmentServiceApi {

  /**
  * Constructs a new AssessmentServiceApi.
  * @alias module:api/AssessmentServiceApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instanc
  e} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  /**
   * Callback function to receive the result of the freezeAssessment operation.
   * @callback moduleapi/AssessmentServiceApi~freezeAssessmentCallback
   * @param {String} error Error message, if any.
   * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Toggle BI visibility of checklist by id
   * Toggle visibility ot the selected checklist from the BI dashboard
   * @param {Number} fiscalYear
   * @param {Number} periodId
   * @param {Boolean} destinationFreezeFlag
   * @param {module:api/AssessmentServiceApi~freezeAssessmentCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  freezeAssessment(fiscalYear, periodId, destinationFreezeFlag, callback) {

    let postBody = null;
    // verify the required parameter 'fiscalYear' is set
    if (fiscalYear === undefined || fiscalYear === null) {
      throw new Error("Missing the required parameter 'fiscalYear' when calling freezeAssessment");
    }
    // verify the required parameter 'periodId' is set
    if (periodId === undefined || periodId === null) {
      throw new Error("Missing the required parameter 'periodId' when calling freezeAssessment");
    }
    // verify the required parameter 'destinationFreezeFlag' is set
    if (destinationFreezeFlag === undefined || destinationFreezeFlag === null) {
      throw new Error("Missing the required parameter 'destinationFreezeFlag' when calling freezeAssessment");
    }

    let pathParams = {

    };
    let queryParams = {
      'fiscalYear': fiscalYear, 'periodId': periodId, 'destinationFreezeFlag': destinationFreezeFlag
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['*/*'];
    let returnType = RestBodyResponseUtil;

    return this.apiClient.callApi(
      '/api/assessment/freeze-assessment', 'PUT',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the getAssessment operation.
   * @callback moduleapi/AssessmentServiceApi~getAssessmentCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/AssessmentDTO>{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get list of assessment
   * Request of the assessment in the application, with the state (frozen or not) and editability (can be frozen/unfrozen or not)
   * @param {module:api/AssessmentServiceApi~getAssessmentCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  getAssessment(callback) {

    let postBody = null;

    let pathParams = {

    };
    let queryParams = {

    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['*/*'];
    let returnType = [AssessmentDTO];

    return this.apiClient.callApi(
      '/api/assessment/monitor', 'GET',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }

    getAssessmentMonitor(callback) {

    let postBody = null;

    let pathParams = {

    };
    let queryParams = {

    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['*/*'];
    let returnType = [AssessmentDTO];

    return this.apiClient.callApi(
      '/api/assessment/monitor-override', 'GET',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }

  /**
   * Callback function to receive the result of the getAssessmentOverride operation.
   * @callback moduleapi/AssessmentServiceApi~getAssessmentOverrideCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/AssessmentDTO>{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get list of assessment overrides
   * Request of the assessment overrides in the application
   * @param {Number} fiscalYear The fiscal year
   * @param {String} period The period
   * @param {module:api/AssessmentServiceApi~getAssessmentOverrideCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  getAssessmentOverride(fiscalYear, period, callback) {
    let postBody = null;

    // verify the required parameter 'fiscalYear' is set
    if (fiscalYear === undefined || fiscalYear === null) {
      throw new Error("Missing the required parameter 'fiscalYear' when calling getAssessmentOverride");
    }

    // verify the required parameter 'period' is set
    if (period === undefined || period === null) {
      throw new Error("Missing the required parameter 'period' when calling getAssessmentOverride");
    }

    let pathParams = {};
    let queryParams = {
      'fiscalYear': fiscalYear,
      'period': period
    };
    let headerParams = {};
    let formParams = {};

    let authNames = [];
    let contentTypes = [];
    let accepts = ['*/*'];
    let returnType = [IntegratedSummaryReportDTO];

    return this.apiClient.callApi(
      '/api/assessment/check-list-override-monitor', 'GET',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }


  getQualitativeAnswer(callback) {
    let postBody = null;

   

    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};

    let authNames = [];
    let contentTypes = [];
    let accepts = ['*/*'];
    let returnType = [TemplateQualitativeAnswerTypeDTO];

    return this.apiClient.callApi(
      '/api/assessment/qualitative-answer-types', 'GET',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }

  saveScoreOverrides(batchDTO, callback) {
    // Verifica che il parametro sia presente
    if (batchDTO === undefined || batchDTO === null) {
      throw new Error("Missing the required parameter 'batchDTO' when calling saveScoreOverrides");
    }

    const postBody = batchDTO;

    const pathParams = {};
    const queryParams = {};
    const headerParams = {};
    const formParams = {};

    const authNames = [];
    const contentTypes = ['application/json'];
    const accepts = ['*/*'];
    const returnType = null;

    return this.apiClient.callApi(
      '/api/assessment/save-batch-score-override',
      'POST',
      pathParams,
      queryParams,
      headerParams,
      formParams,
      postBody,
      authNames,
      contentTypes,
      accepts,
      returnType,
      callback
    );
  }


}
